import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import Page from "@app/components/pageTypes/Page/Page"
import { useGetStrings } from "@app/store/service/cmsService"

export const OrderFailed = () => {
	const { replace } = useCustomNavigation()

	const { data } = useGetStrings()
	const { orderFailedTitle, orderFailedText, orderFailedButton } = data || {}

	return (
		<Page className="container-md pt-12 px-4">
			<h1 className="color-fg-red-900 f2 mb-3 text-center">{orderFailedTitle}</h1>
			<div className="color-bg-red-100 p-3">
				<span className="color-fg-red-900">{orderFailedText}</span>
			</div>

			<div className="mt-3 container-sm">
				<Button
					onClick={() => {
						replace("/order/order-overview")
					}}
					style="secondary"
				>
					{orderFailedButton}
				</Button>
			</div>
		</Page>
	)
}
